export const operationsManagerRoute = {
  base: '/operations-manager',
  jobs: '/jobs',
  crm: '/crm',
  leads: '/leads',
  clients: '/clients',
  communication: '/communication',
  quotes: '/quotes',
  inventory: '/inventory',
  product: '/product',
  package: '/package',
  settings: '/settings',
  users: '/users',
  schedule: '/schedule',
  vehicles: '/vehicles',
  trucks: '/trucks',
  equipments: '/equipments',
  trailers: '/trailers',
  vendors: '/vendors',
  purchaseOrder: '/purchase-order',
  order: '/order',
  roleManagement: '/role-management',
  coupon: '/coupon',
  eventType: '/event-type',
  category: '/category',
  quarantines: '/quarantine',
  invoice: '/invoice',
  checklist: '/checklist',
  task: '/task',
  global: '/global',
  venue: '/venue',

  // Reports
  reports: '/reports',
  overbookingItem: '/overbooking-item',
  subrentalsReport: '/subrentals',
  quarantineReport: '/quarantine',
  foremanTaskReport: '/foreman-task-completion',
  clientIncomeReport: '/client-income',
  revenueReport: '/revenue',
  geographicRevenueReport: '/geographic-revenue',
  quoteRevenueReport: '/quote-revenue',
  orderRevenueReport: '/order-revenue',
  cancellationReport: '/cancellation',
  deliveryReport: '/delivery-pickup',
  taskCompletionReport: '/task-completion',
  discountUsageReport: '/discount-usage',
  featureUtilizationReport: '/feature-utilization',
  jobCostingReport: '/job-costing',
  inventoryUsageReport: '/inventory-usage',
  marketingRevenueReport: '/marketing-revenue',
  financialOrderReport: '/financial-order',
  transactionSummaryReport: '/transaction-summary',

  // Common
  commonCreate: '/create',
  commonEdit: '/edit',
  commonClone: '/clone',
  commonDetail: '/:id',
};

export const operationsManagerRouteVehicles = {
  vehicles: `${operationsManagerRoute.base}${operationsManagerRoute.vehicles}`,
};

export const operationsManagerRouteTrucks = {
  trucks: `${operationsManagerRoute.base}${operationsManagerRoute.vehicles}${operationsManagerRoute.trucks}`,
};

export const operationsManagerRouteEquipments = {
  equipments: `${operationsManagerRoute.base}${operationsManagerRoute.vehicles}${operationsManagerRoute.equipments}`,
};

export const operationsManagerRouteTrailers = {
  trailers: `${operationsManagerRoute.base}${operationsManagerRoute.vehicles}${operationsManagerRoute.trailers}`,
};

export const operationsManagerRouteVendors = {
  vendors: `${operationsManagerRoute.base}${operationsManagerRoute.vendors}`,
  detailVendor: `${operationsManagerRoute.base}${operationsManagerRoute.vendors}${operationsManagerRoute.commonDetail}`,
};

export const operationsManagerRoutePurchaseOrder = {
  purchaseOrder: `${operationsManagerRoute.base}${operationsManagerRoute.purchaseOrder}`,
  detailPurchaseOrder: (purchaseOrderId: string) =>
    `${operationsManagerRoute.base}${operationsManagerRoute.purchaseOrder}/${purchaseOrderId}`,
};

export const operationsManagerRouteOrder = {
  order: `${operationsManagerRoute.base}${operationsManagerRoute.order}`,
  detailOrder: (orderId: string) => `${operationsManagerRoute.base}${operationsManagerRoute.order}/${orderId}`,
  updateOrder: (orderId: string) =>
    `${operationsManagerRoute.base}${operationsManagerRoute.order}/${orderId}${operationsManagerRoute.commonEdit}`,
};

export const operationsManagerRouteCrm = {
  crm: `${operationsManagerRoute.base}${operationsManagerRoute.crm}`,
  leads: `${operationsManagerRoute.base}${operationsManagerRoute.crm}${operationsManagerRoute.leads}`,
  createLead: `${operationsManagerRoute.base}${operationsManagerRoute.crm}${operationsManagerRoute.leads}${operationsManagerRoute.commonCreate}`,
  detailLead: (leadId: string) =>
    `${operationsManagerRoute.base}${operationsManagerRoute.crm}${operationsManagerRoute.leads}/${leadId}`,
  updateLead: (leadId: string) =>
    `${operationsManagerRoute.base}${operationsManagerRoute.crm}${operationsManagerRoute.leads}/${leadId}${operationsManagerRoute.commonEdit}`,
  clients: `${operationsManagerRoute.base}${operationsManagerRoute.crm}${operationsManagerRoute.clients}`,
  createClient: `${operationsManagerRoute.base}${operationsManagerRoute.crm}${operationsManagerRoute.clients}${operationsManagerRoute.commonCreate}`,
  detailClient: (clientId: string) =>
    `${operationsManagerRoute.base}${operationsManagerRoute.crm}${operationsManagerRoute.clients}/${clientId}`,
  updateClient: (clientId: string) =>
    `${operationsManagerRoute.base}${operationsManagerRoute.crm}${operationsManagerRoute.clients}/${clientId}${operationsManagerRoute.commonEdit}`,
};

export const operationsManagerRouteQuote = {
  quotes: `${operationsManagerRoute.base}${operationsManagerRoute.quotes}`,
  createQuotes: `${operationsManagerRoute.base}${operationsManagerRoute.quotes}${operationsManagerRoute.commonCreate}`,
  detailQuote: (quoteId: string) => `${operationsManagerRoute.base}${operationsManagerRoute.quotes}/${quoteId}`,
  updateQuote: (quoteId: string) =>
    `${operationsManagerRoute.base}${operationsManagerRoute.quotes}/${quoteId}${operationsManagerRoute.commonEdit}`,
};

export const operationsManagerRouteInventory = {
  inventories: `${operationsManagerRoute.base}${operationsManagerRoute.inventory}`,
  inventory: `${operationsManagerRoute.base}${operationsManagerRoute.inventory}${operationsManagerRoute.product}`,
  createInventory: `${operationsManagerRoute.base}${operationsManagerRoute.inventory}${operationsManagerRoute.product}${operationsManagerRoute.commonCreate}`,
  detailInventory: (inventoryId: string) =>
    `${operationsManagerRoute.base}${operationsManagerRoute.inventory}${operationsManagerRoute.product}/${inventoryId}`,
  updateInventory: (inventoryId: string) =>
    `${operationsManagerRoute.base}${operationsManagerRoute.inventory}${operationsManagerRoute.product}/${inventoryId}${operationsManagerRoute.commonEdit}`,
};

export const operationsManagerRoutePackage = {
  package: `${operationsManagerRoute.base}${operationsManagerRoute.inventory}${operationsManagerRoute.package}`,
  createPackage: `${operationsManagerRoute.base}${operationsManagerRoute.inventory}${operationsManagerRoute.package}${operationsManagerRoute.commonCreate}`,
  updatePackage: (packageId: string) =>
    `${operationsManagerRoute.base}${operationsManagerRoute.inventory}${operationsManagerRoute.package}/${packageId}${operationsManagerRoute.commonEdit}`,
  clonePackage: (packageId: string) =>
    `${operationsManagerRoute.base}${operationsManagerRoute.inventory}${operationsManagerRoute.package}/${packageId}${operationsManagerRoute.commonClone}`,
};

export const operationsManagerRouteUser = {
  users: `${operationsManagerRoute.base}${operationsManagerRoute.settings}${operationsManagerRoute.users}`,
  createUser: `${operationsManagerRoute.base}${operationsManagerRoute.settings}${operationsManagerRoute.users}${operationsManagerRoute.commonCreate}`,
  detailUser: (userId: string) =>
    `${operationsManagerRoute.base}${operationsManagerRoute.settings}${operationsManagerRoute.users}/${userId}`,
  updateUser: (userId: string) =>
    `${operationsManagerRoute.base}${operationsManagerRoute.settings}${operationsManagerRoute.users}/${userId}${operationsManagerRoute.commonEdit}`,
};

export const operationsManagerRouteVenue = {
  venue: `${operationsManagerRoute.base}${operationsManagerRoute.settings}${operationsManagerRoute.venue}`,
  createVenue: `${operationsManagerRoute.base}${operationsManagerRoute.settings}${operationsManagerRoute.venue}${operationsManagerRoute.commonCreate}`,
  detailVenue: (venueId: string) =>
    `${operationsManagerRoute.base}${operationsManagerRoute.settings}${operationsManagerRoute.venue}/${venueId}`,
  updateVenue: (venueId: string) =>
    `${operationsManagerRoute.base}${operationsManagerRoute.settings}${operationsManagerRoute.venue}/${venueId}${operationsManagerRoute.commonEdit}`,
};

export const operationsManagerRouteInvoice = {
  invoices: `${operationsManagerRoute.base}${operationsManagerRoute.invoice}`,
  createInvoice: `${operationsManagerRoute.base}${operationsManagerRoute.invoice}${operationsManagerRoute.commonCreate}`,
  updateInvoice: (invoiceId: string) =>
    `${operationsManagerRoute.base}${operationsManagerRoute.invoice}/${invoiceId}${operationsManagerRoute.commonEdit}`,
};

export const operationsManagerRouteRoleManagement = {
  roleManagement: `${operationsManagerRoute.base}${operationsManagerRoute.settings}${operationsManagerRoute.roleManagement}`,
  createRole: `${operationsManagerRoute.base}${operationsManagerRoute.settings}${operationsManagerRoute.roleManagement}${operationsManagerRoute.commonCreate}`,
  updateRole: (roleId: string) =>
    `${operationsManagerRoute.base}${operationsManagerRoute.settings}${operationsManagerRoute.roleManagement}/${roleId}${operationsManagerRoute.commonEdit}`,
};

export const operationsManagerRouteRoleCoupon = {
  coupon: `${operationsManagerRoute.base}${operationsManagerRoute.settings}${operationsManagerRoute.coupon}`,
};

export const operationsManagerRouteRoleEventType = {
  eventType: `${operationsManagerRoute.base}${operationsManagerRoute.settings}${operationsManagerRoute.eventType}`,
};

export const operationsManagerRouteRoleCategory = {
  category: `${operationsManagerRoute.base}${operationsManagerRoute.settings}${operationsManagerRoute.category}`,
};

export const operationsManagerRouteRoleChecklist = {
  checklist: `${operationsManagerRoute.base}${operationsManagerRoute.settings}${operationsManagerRoute.checklist}`,
};

export const operationsManagerRouteJob = {
  jobs: `${operationsManagerRoute.base}${operationsManagerRoute.jobs}`,
  detailJob: (jobId: string) => `${operationsManagerRoute.base}${operationsManagerRoute.jobs}/${jobId}`,
};

export const operationsManagerRouteQuarantine = {
  quarantine: `${operationsManagerRoute.base}${operationsManagerRoute.inventory}${operationsManagerRoute.quarantines}`,
};

export const operationsManagerRouteTask = {
  task: `${operationsManagerRoute.base}${operationsManagerRoute.task}`,
};

export const operationsManagerRouteGlobal = {
  global: `${operationsManagerRoute.base}${operationsManagerRoute.global}`,
};

export const operationsManagerRouteReport = {
  reports: `${operationsManagerRoute.base}${operationsManagerRoute.reports}`,
  overbookingItem: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.overbookingItem}`,
  subrentalsReport: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.subrentalsReport}`,
  clientIncomeReport: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.clientIncomeReport}`,
  revenueReport: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.revenueReport}`,
  geographicRevenueReport: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.geographicRevenueReport}`,
  quoteRevenueReport: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.quoteRevenueReport}`,
  orderRevenueReport: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.orderRevenueReport}`,
  cancellationReport: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.cancellationReport}`,
  deliveryReport: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.deliveryReport}`,
  taskCompletionReport: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.taskCompletionReport}`,
  discountUsageReport: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.discountUsageReport}`,
  featureUtilizationReport: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.featureUtilizationReport}`,
  jobCostingReport: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.jobCostingReport}`,
  inventoryUsageReport: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.inventoryUsageReport}`,
  quarantineReport: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.quarantineReport}`,
  foremanTaskReport: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.foremanTaskReport}`,
  marketingRevenueReport: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.marketingRevenueReport}`,
  financialOrderReport: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.financialOrderReport}`,
  transactionSummaryReport: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.transactionSummaryReport}`,
};

export const operationsManagerRouteAbsolute = {
  // Dashboard
  dashboard: operationsManagerRoute.base,

  // Communication
  communication: `${operationsManagerRoute.base}${operationsManagerRoute.communication}`,

  // Settings
  settings: `${operationsManagerRoute.base}${operationsManagerRoute.settings}`,

  // Schedule
  schedule: `${operationsManagerRoute.base}${operationsManagerRoute.schedule}`,

  ...operationsManagerRouteVehicles,
  ...operationsManagerRouteTrucks,
  ...operationsManagerRouteEquipments,
  ...operationsManagerRouteTrailers,
  ...operationsManagerRouteVendors,
  ...operationsManagerRoutePurchaseOrder,
  ...operationsManagerRouteOrder,
  ...operationsManagerRouteCrm,
  ...operationsManagerRouteQuote,
  ...operationsManagerRouteInventory,
  ...operationsManagerRoutePackage,
  ...operationsManagerRouteUser,
  ...operationsManagerRouteVenue,
  ...operationsManagerRouteRoleManagement,
  ...operationsManagerRouteRoleCoupon,
  ...operationsManagerRouteRoleEventType,
  ...operationsManagerRouteRoleCategory,
  ...operationsManagerRouteRoleChecklist,
  ...operationsManagerRouteJob,
  ...operationsManagerRouteQuarantine,
  ...operationsManagerRouteInvoice,
  ...operationsManagerRouteReport,
  ...operationsManagerRouteTask,
  ...operationsManagerRouteGlobal,
};
